<template>
    <span :class='type' @click="handleClick">
        {{name}}
    </span>
</template>

<script>
export default {
    name: "Button",
    props: {
        type: {
            type: String,
            default: 'btnBlue'
        },
        name: String,
        callback: Function
    },
    methods: {
        handleClick(){
            this.$emit('handleClick')
        }

    }

}
</script>

<style scoped lang="less">
.btnBlue {
    box-sizing: border-box;
    display: inline-block;
    min-width: 124px;
    padding: 0 24px;
    line-height: 32px;
    height: 34px;
    border: 1px solid #0699EE;
    text-align: center;
    background: linear-gradient(305deg, #0095EB 0%, #2CB2FF 100%, #2CB2FF 100%);
    box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.4);
    border-radius: 15px;
    cursor: pointer;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    &:active {
        box-shadow: none;
    }
}

.btnGray {
    box-sizing: border-box;
    display: inline-block;
    min-width: 124px;
    padding: 0 24px;
    line-height: 32px;
    height: 34px;
    text-align: center;
    background: #E0EBF2;
    box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.2);
    border: 1px solid #0699EE;
    border-radius: 15px;
    cursor: pointer;
    font-size: 18px;
    color: #15A3F5;
    font-weight: 500;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    &:active {
        box-shadow: none;
    }
}

</style>